import { NARRATIVE_VALUATOR_COMPANY_FRAGMENT } from '@/pages/Narrative/hooks/narrativeValuatorCompanyFragment';
import { gql } from '@/utilities/gql';
import { makeGqlSuspenseQuery } from '@/utilities/gqlQuery';
import { NARRATIVE_MINI_VALUATOR_EDIT_NARRATIVE_FRAGMENT } from '../components/NarrativeMiniValuatorFormEdit';

const QUERY = gql(
  `
  query NarrativeMiniValuatorCompany($canonicalUrl: String!) {
    Company(canonicalURL: $canonicalUrl) {
      id
      name
      tickerSymbol
      canonicalURL
      info {
        url
      }
      ...NarrativeValuatorCompanyFields

      myNarrative {
        ...NarrativeMiniValuatorEditNarrativeFields
      }
    }
  }
`,
  [
    NARRATIVE_VALUATOR_COMPANY_FRAGMENT,
    NARRATIVE_MINI_VALUATOR_EDIT_NARRATIVE_FRAGMENT,
  ]
);

export const useNarrativeMiniValuatorCompany = makeGqlSuspenseQuery(QUERY, {
  tags: ['narrative', 'narrative-mini-valuator'],
});
